
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProductsSection from './components/ProductsSection';
import WhyUsSection from './components/WhyUsSection';
import BrandsSlider from './components/BrandsSlider';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* pt-24 لتعويض ارتفاع الهيدر الثابت */}
      <main className="pt-24">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProductsSection />
        <WhyUsSection />
        <BrandsSlider />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
